// extracted by mini-css-extract-plugin
export default {"cell":"Categories_cell__alhrW","first":"Categories_first__2g1dD","last":"Categories_last__jmuUE","editable":"Categories_editable__6iqtz"};